import { useCallback, useEffect, useRef, useState } from "react";
import { getEdgeQuantifier } from "../api/quontxApi";
import HeatmapPlot from "../components/HeatmapPlot";

const HeatmapPlotFilters = ({ propagnateData }) => {
  const propagnateFunctionRef = useRef(propagnateData);

  const [data, setData] = useState({});
  const [objects, setObjects] = useState([]);
  const [shape, setShape] = useState([]);
  const [loadingData, setLoadingData] = useState(false);

  const loadCausilityScores = useCallback(async () => {
    const scores = await getEdgeQuantifier({
      itemsPerPage: 650,
      nodes: ["test"],
      edgeType: "causal",
    });
    propagnateFunctionRef.current(scores.data);

    setData(scores.data.data);
    setShape(scores.data.metadata.shape);
    setObjects(scores.data.metadata.objects);
  }, []);

  useEffect(() => {
    (async () => {
      setLoadingData(true);
      await loadCausilityScores();
      setLoadingData(false);
    })();
  }, [loadCausilityScores]);

  return (
    <div className="w-full flex flex-col items-center content-center">
      {data && objects && shape && (
        <div className="flex flex-col gap-4 items-center justify-center mb-8">
          <div className="flex items-center content-center flex-wrap">
            <HeatmapPlot
              isLoading={loadingData}
              data={data}
              objects={objects}
              shape={shape}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HeatmapPlotFilters;
